export default "__VITE_ASSET__BFCaj0_8__"